module.exports = __webpack_public_path__ + "static/media/303KnobLabel--cutOffFreq.ca9227a2.svg";